export class DocumentMetadata {
    fileName: string
    date: Date
    metadataId: string

    fileSize: number
    responseSize: number = 0
    fileResponseDifference: number = 0;
    Version: number = 0

    progress: number = 0
    loading: boolean = true
    success: boolean
    downloading: boolean = false

    unitOfMeasurementString: string
    unitOfMeasurementValue: number

    showCopyAlert: boolean;
    constructor(fileName: string, date: Date, fileSize: number, metadataId: string, version?: number, success?: any, loading?: any){
        this.fileName = fileName
        this.date = date
        this.fileSize = fileSize
        this.metadataId = metadataId
        if (version != null) this.Version = version
        if (success != null) this.success = success
        if (loading != null) this.loading = loading
    }
}